module.exports = __webpack_public_path__ + "static/eyecare-300a0dcc35ef87d77ed390b2722a31ba.png";